<template>
    <el-dialog
        :visible.sync="dialogVisible"
        title="字段权限"
        :close-on-press-escape="false"
        width="600px"
        append-to-body
        :before-close="handleClose">
        <div class="content-box">
            <div class="top-tool-bar mb6">
                <span class="check-all-btn width120" @click="checkAll('view')">全选</span>
                <span class="check-all-btn width120" @click="checkAll('edit')">全选</span>
            </div>
            <el-form ref="form" label-width="150px" class="form-wrap">
                <el-form-item :label="item.display_name+'：'" v-for="item in fieldsData" class="mb6">
                    <el-checkbox class="width120" v-model="item.checked" :disabled="item.disabled||isView" @change="checkView(item,$event)">查看</el-checkbox>
                    <el-checkbox class="width120" v-model="tag_action_ids_editable[item.name]" :disabled="notEditableFields.includes(item.name)||isView||isPageNoEditField" @change="checkEdit(item,$event)">编辑</el-checkbox>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div slot="footer" class="dialog-footer tac" v-else>
            <el-button type="default" @click="cancelSubmit" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import util from '@/libs/utils';

    export default {
        name: "TagFieldsConfig",
        components: {},
        props: {
            fields: {
                type: Array,
                required: true
            },
            page:{
                type: Object,
                required: true
            },
            isView:{
                type: Boolean,
                default:false,
            },
            tagEditable:{
                type: Object,
                required: true
            },
        },
        data() {
            return {
                dialogVisible: false,
                fieldsData: [],
                oldData:[],
                curErrMsg:null,
                tag_action_ids_editable:{},
                notEditableFields:[],
            }
        },
        computed: {
            isPageNoEditField(){
                let page = this.page||{};
                let pageFunc = page.func||[];
                let editFunc = this._findModuleByName(pageFunc,'edit');
                return editFunc?!editFunc.checked:true;
            }
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.notEditableFields = [];
            },
            resetData(){
                console.log('resetData');
                this.notEditableFields = [];
            },
            showModal(){
                this.dialogVisible = true;
                this.notEditableFields = [];
                this.$nextTick(()=>{
                    console.log(333,this.fields,this.tagEditable);
                    let fields = this.fields||[];
                    this.fieldsData = util.deepClone(fields);

                    let pageTagEditable = (this.tagEditable[this.page.id]||"").split(',');
                    fields.forEach(item=>{
                        console.log('11',item.config)
                        let config = JSON.parse(item.config||"{}")||{};
                        if(config.editable=='false'){
                            this.notEditableFields.push(item.name);
                        }
                        this.$set(this.tag_action_ids_editable,item.name,pageTagEditable.includes(item.id));
                    })
                })
            },
            cancelSubmit(){
                this.dialogVisible = false;
                this.resetData();
            },
            handleSubmit() {


                let viewChecked = this.fieldsData.filter(item=>item.checked);
                let editChecked = [];

                this.fieldsData.forEach(item=>{
                    if(this.tag_action_ids_editable[item.name]){
                        editChecked.push(item.id);
                    }
                });

                console.log('save-tag-fields',this.page,viewChecked,editChecked);
                this.$emit('save-fields',this.page,viewChecked,editChecked);
                this.handleClose();

                // let actionIds = this._getCheckedVal(this.fieldsData,[]);
                // this.oldData = this._fmtTreeData(util.deepClone(this.fieldsData));
                // this.$emit('save-fields',this.page,actionIds,this.actionType);
                // this.handleClose();

            },
            checkAll(type){
                if(this.isView) return false;
                if(type=='view'){
                    this.fieldsData.forEach(item=>{
                        if(!item.disabled){
                            item.checked = true;
                        }
                    })
                }else if(type=='edit'){
                    if(this.isPageNoEditField) return false;
                    this.fieldsData.forEach(item=>{
                        if(!this.notEditableFields.includes(item.name)){
                            this.tag_action_ids_editable[item.name] = true;
                            if(!item.checked){
                                item.checked = true;
                            }
                        }
                    })
                }
            },
            checkEdit(item,val){
                console.log('checkEdit',item,val);
                if(val===true&&item.checked===false){
                    item.checked = true;
                }
            },
            checkView(item,val){
                if(val===false&&this.tag_action_ids_editable[item.name]===true){
                    this.tag_action_ids_editable[item.name] = false;
                }
            },


            _findModuleByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },

        },
    }
</script>

<style lang="scss" scoped>
    .top-tool-bar{
        padding-left: 150px;
        .check-all-btn{
            display: inline-block;
            text-indent: 10px;
            cursor: pointer;
        }
    }
    .form-wrap{
        max-height: 300px;
        overflow-y: auto;
    }
    .width120{
        width: 150px;
    }
    .mb6{
        margin-bottom: 6px!important;
    }
</style>
